

<div class="hidden sm:inline">
    <button matButton="elevated" type="button"
            [disabled]="disabled()"
            (click)="buttonClick.emit($event)">
        <mat-icon>{{ icon() }}</mat-icon>
        <span>{{ label() }}</span>
    </button>
</div>

<div class="sm:hidden">
    <button matMiniFab type="button"      
            [disabled]="disabled()"
            (click)="buttonClick.emit($event)">
        <mat-icon>{{ icon() }}</mat-icon>
    </button>
</div>
